export const listResourcesQuery = /* GraphQL */ `
  query ListResources($filter: ModelResourceFilterInput, $limit: Int, $nextToken: String) {
    listResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        resourceName
        description
        resourcePath
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
